import * as i0 from "@angular/core";
export class HomeInformationStore {
}
HomeInformationStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HomeInformationStore_Factory() { return new HomeInformationStore(); }, token: HomeInformationStore, providedIn: "root" });
export var HomeInformationStoreKeys;
(function (HomeInformationStoreKeys) {
})(HomeInformationStoreKeys || (HomeInformationStoreKeys = {}));
